export default "__VITE_ASSET__CCIgd31o__"